module.exports = __webpack_public_path__ + "static/media/line.586f1122.svg";